import type {AxiosError} from 'axios';
import {useMutation} from '@tanstack/react-query';

import {api} from '@eksab/api';

interface AttachUserPrizeParams {
  id: string;
}

export const useAttachUserPrizeMutation = (attemptID: string) =>
  useMutation<unknown, AxiosError, AttachUserPrizeParams>(({id}) =>
    api
      .post(`v1/attempts/${attemptID}/attach-user-prize`, {
        guest_id: id,
      })
      .then((res) => res.data),
  );
